module.exports = __webpack_public_path__ + "img/icon_option.94b35484.svg";